import React from 'react';
import roomIconRedLg from '../../../assets/images/roomIconRedLg.png';
import roomIconWhiteLg from '../../../assets/images/roomIconWhiteLg.png';
import statusIconRedLg from '../../../assets/images/statusIconRedLg.png';
import statusIconWhiteLg from '../../../assets/images/statusIconWhiteLg.png';
import confirmIconRedLg from '../../../assets/images/confirmIconRedLg.png';
import confirmIconWhiteLg from '../../../assets/images/confirmIconWhiteLg.png';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../store/langSlice';
import { getLang } from '../../../environnement';
import { Link } from 'react-router-dom';

function ProcedureItem({
  title,
  icon,
  iconHovered,
  link
}) {
  return (
    <Link to={link}>
      <div className='group mx-14 flex flex-col items-center h-96 cursor-pointer'>
        <div className='rounded-full border border-primary w-60 h-60 flex justify-center items-center group-hover:bg-primary'>
          <img src={icon} alt='itemIcon' className='group-hover:hidden'/>
          <img src={iconHovered} alt='itemIcon' className='hidden group-hover:inline'/>
        </div>
        <p className='font-medium text-primary text-xl text-center w-40 mt-5'>{title}</p>
      </div>
    </Link>
  );
}

export default function Procedure({
  procedureDiv
}) {
  const lang = useSelector(langSelector);

  return (
    <div ref={procedureDiv}>
      {/* <p className='text-primary text-3xl font-medium text-center my-10'>{getLang(lang).accueil.procedure}</p> */}
      <div className='flex flex-col justify-center items-center pt-5 pb-10 lg:flex-row'>
        <ProcedureItem icon={roomIconRedLg} iconHovered={roomIconWhiteLg} title={getLang(lang).accueil.demandeReservationSalle} link='/demande-salle' />
        <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
        <ProcedureItem icon={statusIconRedLg} iconHovered={statusIconWhiteLg} title={getLang(lang).accueil.suivreEtatDemande} link='/suivre-demande-login' />
        <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
        <ProcedureItem icon={confirmIconRedLg} iconHovered={confirmIconWhiteLg} title={getLang(lang).accueil.confirmationDemande} link='/suivre-demande-login' />
      </div>
    </div>
  );
}
